import React, {Component} from 'react';
import './Header.css';

class Header extends Component {
    render() {
        return (
            <div className="row">
                <div id="heading" className="col-11"><h1>{this.props.title}</h1></div>
                <div className="col-1 text-right" id="user_icon">
                    {/* 
                    replace w/ font icon
                    <i className="fas fa-user-circle larger-font" aria-hidden="true"/> */}
                </div>
                <hr/>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js